import React, { useState } from 'react';
import { CalendarDaysIcon, CheckCircle2Icon, MountainIcon, UsersIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
const inputClass = 'mt-2 w-full border border-[#bcb3a1] bg-[#f7f4ec] px-4 py-3 font-normal text-[#1d2d2a] outline-none transition-colors placeholder:text-[#7a857e] focus:border-[#6D5A39] focus:ring-1 focus:ring-[#6D5A39]';
export function BookNowPage() {
  const [submitted, setSubmitted] = useState(false);
  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitted(true);
  }
  return <main className="w-full bg-[#f7f4ec] text-[#1d2d2a]" data-id="element-485" data-mp="1vfewdszajqg3">
      <PageHero eyebrow="Reserve your place" title="Book the Manaslu Circuit." description="Share your travel details and our Kathmandu team will confirm availability, permits, and the next steps for your preferred departure." image="https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&w=1800&q=85" data-id="element-486" data-mp="1vgzrbjpipbeh" />

      <section className="mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:px-8 sm:py-24 lg:grid-cols-[0.78fr_1.22fr] lg:px-10" data-id="element-487" data-mp="2ymmpvrquhd4n">
        <aside className="lg:sticky lg:top-28 lg:self-start" data-id="element-488" data-mp="32mwup12whxhx">
          <p className="eyebrow" data-id="element-489" data-mp="37grb9vn7lwcs">Your selected journey</p>
          <h2 className="mt-4 font-display text-4xl leading-tight" data-id="element-490" data-mp="3cet3b62m560e">
            Manaslu Circuit Trek
          </h2>
          <p className="mt-5 max-w-md text-base leading-8 text-[#55615a]" data-id="element-491" data-mp="2fp1yacwp40gc">
            A carefully paced 10-day journey through river gorges, Nubri
            villages, and the high crossing of Larkya La.
          </p>

          <div className="mt-8 border-y border-[#c8c1af]" data-id="element-492" data-mp="2oo6v9eslzlqe">
            <div className="flex items-start gap-3 py-5" data-id="element-493" data-mp="2tobgfi4gp4my">
              <MountainIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#6D5A39]" aria-hidden="true" data-id="element-494" data-mp="2tpw88zze69h4" />
              <div data-id="element-495" data-mp="8xu41oqlpb1c">
                <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#6D5A39]" data-id="element-496" data-mp="8xawn1yku51k">
                  Trip name
                </p>
                <p className="mt-1 font-display text-2xl" data-id="element-497" data-mp="3fdhxqbjo16lu">
                  Manaslu Circuit Trek
                </p>
              </div>
            </div>
            <div className="border-t border-[#c8c1af] py-5" data-id="element-498" data-mp="3pdsajv1sgc0h">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#6D5A39]" data-id="element-499" data-mp="3pb61ts35vqgo">
                Price
              </p>
              <p className="mt-2 font-display text-3xl" data-id="element-500" data-mp="2wobm18hahf9j">US$1,165 pp</p>
              <p className="mt-1 text-sm leading-6 text-[#55615a]" data-id="element-501" data-mp="2wmifrual8x22">
                Two or more travelers. Private solo departure: US$1,560.
              </p>
            </div>
          </div>

          <ul className="mt-8 space-y-4 text-sm leading-6 text-[#55615a]" data-id="element-502" data-mp="36ghc2cnzdmm3">
            <li className="flex gap-3" data-id="element-503" data-mp="31md0fg3rsqeo">
              <CalendarDaysIcon className="h-5 w-5 shrink-0 text-[#6D5A39]" aria-hidden="true" data-id="element-504" data-mp="2dy3mt1gpn8ym" />
              Choose the date that works best for your group.
            </li>
            <li className="flex gap-3" data-id="element-505" data-mp="ogyape3jadz3">
              <UsersIcon className="h-5 w-5 shrink-0 text-[#6D5A39]" aria-hidden="true" data-id="element-506" data-mp="ofx17e261zjh" />
              We will confirm the appropriate price and availability before any
              payment is requested.
            </li>
          </ul>
        </aside>

        <div className="border border-[#c8c1af] bg-[#e9e3d5] p-6 sm:p-8" data-id="element-507" data-mp="jiep5esur479">
          {submitted ? <div className="py-12 text-center" role="status" aria-live="polite" data-id="element-508" data-mp="178iovb2x6jsz">
              <CheckCircle2Icon className="mx-auto h-10 w-10 text-[#6D5A39]" aria-hidden="true" data-id="element-509" data-mp="1c5hh1o30wgoj" />
              <p className="eyebrow mt-5" data-id="element-510" data-mp="128mkvbu82sdf">Booking request received</p>
              <h2 className="mt-4 font-display text-3xl" data-id="element-511" data-mp="126tfs0z9cg7j">
                Thank you for choosing Manaslu.
              </h2>
              <p className="mx-auto mt-4 max-w-md text-sm leading-7 text-[#55615a]" data-id="element-512" data-mp="3myvit8wbb8lq">
                Our team will contact you to confirm your preferred date,
                availability, and booking details.
              </p>
            </div> : <form onSubmit={handleSubmit} aria-label="Manaslu Circuit booking form" data-id="element-513" data-mp="28b20dhvquep">
              <div className="border-b border-[#bcb3a1] pb-6" data-id="element-514" data-mp="3tdubd9weyhl1">
                <p className="eyebrow" data-id="element-515" data-mp="3oiex4guhujo3">Booking details</p>
                <h2 className="mt-3 font-display text-3xl" data-id="element-516" data-mp="pz812poktx8j">
                  Tell us about your group
                </h2>
                <p className="mt-3 text-sm leading-7 text-[#55615a]" data-id="element-517" data-mp="l1exm4enrhby">
                  Fields marked required help us prepare an accurate response.
                </p>
              </div>

              <div className="mt-7 grid gap-5 sm:grid-cols-2" data-id="element-518" data-mp="c0gr9fgqyxq7">
                <label className="text-sm font-bold" data-id="element-519" data-mp="c21k90ney8ly">
                  Full name
                  <input required name="fullName" autoComplete="name" className={inputClass} data-id="element-520" data-mp="30sucltiozecp" />
                </label>

                <label className="text-sm font-bold" data-id="element-521" data-mp="1c62ecf1s7z6k">
                  Nationality
                  <input required name="nationality" autoComplete="country-name" className={inputClass} data-id="element-522" data-mp="1g7e7gujv72ji" />
                </label>

                <label className="text-sm font-bold" data-id="element-523" data-mp="1uyn3bled1k53">
                  Phone number
                  <input required type="tel" name="phone" autoComplete="tel" className={inputClass} data-id="element-524" data-mp="1v0pui8r91jbe" />
                </label>

                <label className="text-sm font-bold" data-id="element-525" data-mp="28x3b7fnylgot">
                  Email
                  <input required type="email" name="email" autoComplete="email" className={inputClass} data-id="element-526" data-mp="9ljyqr3g5qae" />
                </label>

                <label className="text-sm font-bold" data-id="element-527" data-mp="1hvasyy7bgbdp">
                  Number of people
                  <input required type="number" name="people" min="1" defaultValue="2" inputMode="numeric" className={inputClass} data-id="element-528" data-mp="1cxiq5954v4uq" />
                </label>

                <label className="text-sm font-bold" data-id="element-529" data-mp="20s24glgm9m77">
                  Travel date
                  <input required type="date" name="travelDate" className={inputClass} data-id="element-530" data-mp="1vuaf9z7cwe6p" />
                </label>
              </div>

              <label className="mt-5 block text-sm font-bold" data-id="element-531" data-mp="25mzftz1dc7n9">
                Message
                <textarea name="message" rows={6} placeholder="Tell us about your preferred dates, trekking experience, or any questions." className={`${inputClass} resize-y`} data-id="element-532" data-mp="2jia6t1chs8mc" />
              </label>

              <button type="submit" className="mt-7 inline-flex w-full items-center justify-center bg-[#172a27] px-6 py-4 text-sm font-bold text-[#f4f0e7] transition-colors hover:bg-[#314940] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A48C5A] focus-visible:ring-offset-4 sm:w-auto" data-id="element-533" data-mp="335epibdpinim">
                Submit booking request
              </button>
            </form>}
        </div>
      </section>
    </main>;
}